import React from "react";
import StoresFormContextProvider from "../common/context/stores-form.context";

export const withStoresForm = (Component: React.FC) => (props: any) => {
  return <StoresFormContextProvider>{<Component {...props} />}</StoresFormContextProvider>;
};
